import { Controller, useFormContext } from 'react-hook-form'

import { CheckBoxGroup, FF2 } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

import { suspiciousActivityInfoValidate } from '../../../../../hooks'

export const Insurance = () => {
  const { control } = useFormContext<SarEdit>()
  return (
    <Controller
      name="suspiciousActivityInfo.insurance"
      control={control}
      rules={{
        validate: suspiciousActivityInfoValidate
      }}
      render={({ field }) => (
        <FF2
          field={field}
          label="39. Insurance"
          input={(props) => (
            <CheckBoxGroup
              {...props}
              data-qa={'39. Insurance'}
              direction={'vertical'}
              data={[
                { label: 'a. Excessive insurance', value: 'a' },
                { label: 'b. Excessive or unusual cash borrowing against policy/annuity', value: 'b' },
                { label: 'c. Proceeds sent to or received from unrelated third party', value: 'c' },
                { label: 'd. Suspicious life settlement sales insurance (e.g.,STOLI’s, Viaticals)', value: 'd' },
                { label: 'e. Suspicious termination of policy or contract', value: 'e' },
                { label: 'f. Unclear or no insurable interest', value: 'f' },
                { label: 'z. Other', value: 'z' }
              ]}
            />
          )}
        />
      )}
    />
  )
}
